





import Vue from 'vue'
import { IJob } from '../store/state';
import { EventBus } from '../helpers/EventBus.vue' 
import Job from './Job.vue';

interface JobsListComputed {
	jobs: IJob[]
}
interface JobsListMethods {
	focusFirst(): void
}

export default Vue.extend<{}, JobsListMethods, JobsListComputed, {}>({
	name: 'JobsList',
	mounted() {
		EventBus.$on('focusFirst', () => this.focusFirst());
	},
	computed: {
		jobs() {
			return this.$store.getters.jobs;
		}
	},
	methods: {
		focusFirst() {
			const list = this.$refs.list as HTMLElement;
			const first = list.querySelector('a');
			first?.focus();
		}
	},
	components: {
		Job
	}
})
